import { Component } from '@angular/core';

@Component({
    selector: 'prox-action-frm',
    templateUrl: './action-frm.component.html',
    standalone: false
})
export class ActionFrmComponent {}
